import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import CuyoTerritoryExplorer from '../components/map/CuyoTerritoryExplorer';

export default function CuyoExplorer() {
  return (
    <Page>
      <CuyoTerritoryExplorer />
      <EditorialFeature to="/zonas/mendoza/quinta-seccion">
        <FeatureImage><img src="/assets/editorial/quinta-seccion/entorno.jpg" alt="Entorno arbolado de Quinta Sección, Mendoza" /></FeatureImage>
        <FeatureCopy>
          <small>NIDO · GUÍA DE ZONA</small>
          <h2>Quinta Sección,<br />más allá del mapa.</h2>
          <p>Historia, lugares y una mirada local para conocer uno de los barrios más reconocidos de Mendoza.</p>
          <span>Leer la guía editorial <FiArrowUpRight /></span>
        </FeatureCopy>
      </EditorialFeature>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  background: #f7f5ef;
`;
const EditorialFeature = styled(Link)`
  display:grid;max-width:1240px;grid-template-columns:1.08fr .92fr;margin:0 auto;padding:0 28px 110px;color:#29474f;text-decoration:none;
  &:hover img{transform:scale(1.025)}&:hover span{gap:16px}
  @media(max-width:720px){grid-template-columns:1fr;padding:0 16px 76px}
`;
const FeatureImage = styled.div`
  min-height:460px;overflow:hidden;border-radius:26px 0 0 26px;
  img{width:100%;height:100%;object-fit:cover;transition:transform .7s ease}
  @media(max-width:720px){min-height:310px;border-radius:22px 22px 0 0}
`;
const FeatureCopy = styled.div`
  display:flex;flex-direction:column;justify-content:center;padding:clamp(34px,5vw,70px);background:#203a40;border-radius:0 26px 26px 0;color:#fff;
  small{color:#e69a7a;font-size:12px;font-weight:850;letter-spacing:.18em}
  h2{margin:16px 0 20px;font-size:clamp(38px,4.5vw,64px);font-weight:520;line-height:.94;letter-spacing:-.055em}
  p{margin:0;color:rgba(255,255,255,.68);font-size:15px;line-height:1.65}
  span{display:flex;align-items:center;gap:11px;margin-top:30px;color:#f0a487;font-size:12px;font-weight:800;transition:gap .2s}
  @media(max-width:720px){padding:36px 26px;border-radius:0 0 22px 22px}
`;
